import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import { CURRENCY_TYPE, TIME_IN_FORCE, ORDER_TYPE } from 'const/trade'
import setOptionRequestParams from 'utils/setOptionRequestParams'
import getPriceMinTick from 'utils/getPriceMinTick'
import getFixedPriceWithMinTick from 'utils/getFixedPriceWithMinTick'
import getFixedOrderDetail from 'utils/getLocalFixedOrderDetail'

/**
 * 格式化交易请求数据信息
 * @params { object } payload { stock, holding, order, isModify, isCloseOut, orderId, action }
 * @params { boolean } isIb
 * @returns { stock, order, isModify, isCloseOut }
 */
export default function formatOrderRequestToLocalParams(payload, isIb) {
  const request = {
    contract: payload.contract,
    stock: payload.stock,
    isModify: payload.isModify || false,
    isCloseOut: payload.isCloseOut || false
  }

  if (payload.isModify) {
    // 修改订单需要格式化为本地数据
    request.order = getFixedOrderDetail(payload.order, isIb)
  } else if (payload.isCloseOut) {
    // 平仓请求需要根据持仓信息创建反向订单
    const action = payload.holding.position > 0 ? 'SELL' : 'BUY'
    request.order = genInitialOrderParams(
      payload.stock,
      payload.contract,
      action
    )
    request.order.totalQuantity = Math.abs(payload.holding.position)
    if (payload.orderId) request.order.orderId = payload.orderId
  } else {
    // 创建初始订单信息
    request.order = genInitialOrderParams(
      payload.stock,
      payload.contract,
      payload.action
    )
    if (payload.orderId) request.order.orderId = payload.orderId
  }
  return request
}

/**
 * 生成初始化本地订单数据
 */
export function genInitialOrderParams(stock, contract, action) {
  const latestPrice = stock.hourTradingLatestPrice || stock.latestPrice
  const minTick = getPriceMinTick(latestPrice, contract.tickSizes || [])
  const params = {
    __order__: true, // 用来标识本地数据
    action: action || 'BUY',
    orderType: ORDER_TYPE.LMT,
    timeInForce: TIME_IN_FORCE.DAY,
    symbol: stock.symbol,
    market: stock.market,
    secType: stock.secType,
    currency: CURRENCY_TYPE[stock.market],
    outsideRth:
      stock.market === MARKET_TYPE.US && stock.secType === SEC_TYPE.STK,
    attachOrderType: 'NO', // 初始化无附加单
    profitTakerPrice: '',
    profitTakerTif: TIME_IN_FORCE.DAY,
    profitTakerRth: false,
    stopLossPrice: '',
    stopLossTif: TIME_IN_FORCE.DAY,
    stopLossRth: false
  }
  if (stock.secType === SEC_TYPE.OPT) {
    const midAskBid = ((stock.askPrice || 0) + (stock.bidPrice || 0)) / 2
    const optPrice = midAskBid ? Math.max(midAskBid, minTick) : latestPrice
    params.limitPrice = getFixedPriceWithMinTick(optPrice, minTick, true)
    setOptionRequestParams(params, stock)
    params.multiplier = stock.multiplier
  } else {
    params.limitPrice = getFixedPriceWithMinTick(latestPrice, minTick, true)
  }
  return params
}
